import React from 'react';
import styled from 'styled-components';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import FeatureBlock from '../components/common/FeatureBlock';
import FAQ from '../components/common/FAQ';

// Imagens temporárias (serão substituídas por imagens reais)
const pricingImage = 'https://via.placeholder.com/600x400?text=Pricing';

const PricingPage = () => {
  const [activeFAQ, setActiveFAQ] = React.useState(0);
  
  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };
  
  const faqs = [
    {
      question: "Como você protege os dados dos seus clientes?",
      answer: "A proteção de dados do cliente é fundamental na Leadfy. Implementamos medidas de segurança robustas, incluindo criptografia de dados, conformidade com padrões do setor e auditorias de segurança regulares para proteger suas informações."
    },
    {
      question: "Quais recursos estão disponíveis para garantir que eu aproveite ao máximo a Leadfy?",
      answer: "Oferecemos uma variedade de recursos para ajudar você a maximizar o valor da Leadfy, incluindo documentação abrangente, webinars educacionais, suporte técnico dedicado e consultoria estratégica para implementação e otimização."
    },
    {
      question: "Quais integrações a Leadfy oferece?",
      answer: "A Leadfy se integra perfeitamente com mais de 70 sistemas, incluindo as principais plataformas de helpdesk, CRMs, sistemas de gerenciamento de conhecimento e outras ferramentas essenciais para operações de suporte ao cliente."
    },
    {
      question: "Vocês oferecem suporte avançado?",
      answer: "Sim, oferecemos vários níveis de suporte, incluindo opções avançadas com tempos de resposta garantidos, gerentes de sucesso do cliente dedicados e consultoria estratégica para empresas com necessidades complexas."
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <PricingHero>
        <PricingHeroContent>
          <PricingHeroTitle>PLANOS DE PREÇOS</PricingHeroTitle>
          <PricingHeroSubtitle>Agentes de IA para fazer crescer e escalar sua equipe de suporte</PricingHeroSubtitle>
        </PricingHeroContent>
      </PricingHero>

      {/* Pricing Plans Section */}
      <Section>
        <PricingGrid>
          <PricingCard>
            <PricingCardTitle>Basic</PricingCardTitle>
            <PricingCardDescription>Melhore sua eficiência com IA</PricingCardDescription>
            
            <PricingFeatures>
              <PricingFeatureTitle>INCLUI:</PricingFeatureTitle>
              <PricingFeatureList>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Agente de IA para chat</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Autoflows</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Ações personalizadas</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Dashboard de insights</PricingFeatureText>
                </PricingFeatureItem>
              </PricingFeatureList>
            </PricingFeatures>
            
            <PricingCardAction>
              <Button variant="secondary" fullWidth>Obter Cotação</Button>
            </PricingCardAction>
          </PricingCard>
          
          <PricingCardPopular>
            <PopularBadge>MAIS POPULAR</PopularBadge>
            <PricingCardTitle>Professional</PricingCardTitle>
            <PricingCardDescription>Eleve suas capacidades de suporte</PricingCardDescription>
            
            <PricingFeatures>
              <PricingFeatureTitle>TUDO NO BASIC, MAIS:</PricingFeatureTitle>
              <PricingFeatureList>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Agente de IA omnichannel</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Agentes de IA para múltiplas marcas</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Insights avançados de tickets</PricingFeatureText>
                </PricingFeatureItem>
              </PricingFeatureList>
            </PricingFeatures>
            
            <PricingCardAction>
              <Button fullWidth>Obter Cotação</Button>
            </PricingCardAction>
          </PricingCardPopular>
          
          <PricingCard>
            <PricingCardTitle>Enterprise</PricingCardTitle>
            <PricingCardDescription>A solução completa de suporte com IA</PricingCardDescription>
            
            <PricingFeatures>
              <PricingFeatureTitle>TUDO NO PROFESSIONAL, MAIS:</PricingFeatureTitle>
              <PricingFeatureList>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>API Leadfy</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Detecção de lacunas na base de conhecimento e criação de artigos</PricingFeatureText>
                </PricingFeatureItem>
                <PricingFeatureItem>
                  <PricingFeatureIcon>✓</PricingFeatureIcon>
                  <PricingFeatureText>Detecção de lacunas em Autoflow e geração</PricingFeatureText>
                </PricingFeatureItem>
              </PricingFeatureList>
            </PricingFeatures>
            
            <PricingCardAction>
              <Button variant="secondary" fullWidth>Obter Cotação</Button>
            </PricingCardAction>
          </PricingCard>
        </PricingGrid>
      </Section>

      {/* Features Section */}
      <Section background="light">
        <SectionTitle>Construído para líderes de suporte que desejam um serviço mais inteligente e escalável</SectionTitle>
        
        <FeaturesGrid>
          <Card
            title="Agente Assistente"
            hoverable
          >
            Capacite agentes humanos com um copiloto de IA agêntico que fornece análise de tickets, orientação de resolução, suporte de chat de IA e geração de respostas inteligentes — tudo dentro do seu helpdesk.
          </Card>
          
          <Card
            title="QA de Agente"
            hoverable
          >
            Eleve o desempenho do agente humano com garantia de qualidade orientada por IA. Pontue automaticamente as conversas quanto à empatia, gramática, relevância e resolução — fornecendo uma visão completa do desempenho sem trabalho manual.
          </Card>
          
          <Card
            title="Leadfy para Slack"
            hoverable
          >
            Obtenha respostas precisas para perguntas cotidianas — sem sair da conversa. Seja para RH, TI ou suporte ao produto, a Leadfy reduz solicitações repetitivas, aumenta a produtividade interna e oferece ajuda consistente em todos os canais do Slack.
          </Card>
        </FeaturesGrid>
      </Section>

      {/* Pricing Table Section */}
      <Section>
        <SectionTitle>Planos de Preços</SectionTitle>
        <SectionSubtitle>Uma solução de IA para cada equipe de suporte</SectionSubtitle>
        
        <PricingTable>
          <PricingTableHeader>
            <PricingTableHeaderCell>Canais</PricingTableHeaderCell>
            <PricingTableHeaderCell>Basic</PricingTableHeaderCell>
            <PricingTableHeaderCell>Professional</PricingTableHeaderCell>
            <PricingTableHeaderCell>Enterprise</PricingTableHeaderCell>
          </PricingTableHeader>
          
          <PricingTableRow>
            <PricingTableCell>Entregue suporte preciso orientado por IA onde os clientes precisam.</PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
          
          <PricingTableHeader>
            <PricingTableHeaderCell>Automação</PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
          </PricingTableHeader>
          
          <PricingTableRow>
            <PricingTableCell>Otimize interações e personalize experiências de clientes.</PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
          
          <PricingTableRow>
            <PricingTableCell>Coleta de CSAT personalizável</PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
          
          <PricingTableHeader>
            <PricingTableHeaderCell>Gerenciamento de Conteúdo</PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
            <PricingTableHeaderCell></PricingTableHeaderCell>
          </PricingTableHeader>
          
          <PricingTableRow>
            <PricingTableCell>Forneça respostas, identifique lacunas e gere conteúdo com IA.</PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
          
          <PricingTableRow>
            <PricingTableCell>Conecte CRM, dados e bases de conhecimento</PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
          
          <PricingTableRow>
            <PricingTableCell>Detecção de lacunas de conhecimento e criação de artigos</PricingTableCell>
            <PricingTableCell><MinusIcon>-</MinusIcon></PricingTableCell>
            <PricingTableCell><MinusIcon>-</MinusIcon></PricingTableCell>
            <PricingTableCell><CheckIcon>✓</CheckIcon></PricingTableCell>
          </PricingTableRow>
        </PricingTable>
      </Section>

      {/* FAQ Section */}
      <Section background="light">
        <SectionTitle>Perguntas Frequentes</SectionTitle>
        
        <FAQContainer>
          {faqs.map((faq, index) => (
            <FAQ
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={activeFAQ === index}
              toggleFAQ={() => toggleFAQ(index)}
            />
          ))}
        </FAQContainer>
        
        <CenteredButton>
          <Button variant="secondary">Leia Mais FAQs</Button>
        </CenteredButton>
      </Section>

      {/* CTA Section */}
      <Section>
        <SectionTitle>Experimente o Futuro do Suporte ao Cliente</SectionTitle>
        <SectionDescription>
          Transforme seus dados em uma vantagem estratégica com nossa solução de IA autônoma. Diga adeus aos chatbots tradicionais; a Leadfy oferece suporte inteligente e escalável adaptado às suas necessidades únicas.
        </SectionDescription>
        
        <CenteredButton>
          <Button size="large">Solicite uma Demo</Button>
        </CenteredButton>
      </Section>
    </div>
  );
};

// Styled Components
const PricingHero = styled.section`
  background-color: var(--primary-dark);
  padding: var(--spacing-xxl) 0;
  color: var(--white);
`;

const PricingHeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 var(--spacing-lg);
`;

const PricingHeroTitle = styled.h1`
  font-size: var(--font-size-3xl);
  margin-bottom: var(--spacing-md);
`;

const PricingHeroSubtitle = styled.h2`
  font-size: var(--font-size-xl);
  font-weight: 400;
  opacity: 0.9;
`;

const Section = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: ${props => props.background === 'light' ? 'var(--light-bg)' : 'var(--white)'};
`;

const SectionTitle = styled.h2`
  font-size: var(--font-size-3xl);
  text-align: center;
  margin-bottom: var(--spacing-lg);
  color: var(--primary-dark);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionSubtitle = styled.h3`
  font-size: var(--font-size-xl);
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
`;

const SectionDescription = styled.p`
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const PricingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PricingCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    box-shadow: var(--shadow-lg);
  }
`;

const PricingCardPopular = styled(PricingCard)`
  border: 2px solid var(--primary);
  position: relative;
  transform: scale(1.05);
  
  @media (max-width: 1024px) {
    transform: scale(1);
  }
`;

const PopularBadge = styled.div`
  position: absolute;
  top: var(--spacing-md);
  right: var(--spacing-md);
  background-color: var(--primary);
  color: var(--white);
  font-size: var(--font-size-sm);
  font-weight: 600;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--border-radius-md);
`;

const PricingCardTitle = styled.h3`
  font-size: var(--font-size-2xl);
  margin-bottom: var(--spacing-sm);
  color: var(--primary-dark);
`;

const PricingCardDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const PricingFeatures = styled.div`
  flex: 1;
  margin-bottom: var(--spacing-lg);
`;

const PricingFeatureTitle = styled.h4`
  font-size: var(--font-size-sm);
  text-transform: uppercase;
  color: var(--text-light);
  margin-bottom: var(--spacing-md);
  letter-spacing: 1px;
`;

const PricingFeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const PricingFeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--spacing-sm);
`;

const PricingFeatureIcon = styled.span`
  color: var(--primary);
  margin-right: var(--spacing-sm);
`;

const PricingFeatureText = styled.span`
  color: var(--text-primary);
`;

const PricingCardAction = styled.div`
  margin-top: auto;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PricingTable = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
`;

const PricingTableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  background-color: var(--primary-dark);
  color: var(--white);
  
  @media (max-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`;

const PricingTableHeaderCell = styled.div`
  padding: var(--spacing-md);
  font-weight: 600;
  
  @media (max-width: 768px) {
    &:nth-child(3), &:nth-child(4) {
      display: none;
    }
  }
`;

const PricingTableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  border-bottom: 1px solid var(--light-bg);
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`;

const PricingTableCell = styled.div`
  padding: var(--spacing-md);
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    &:nth-child(3), &:nth-child(4) {
      display: none;
    }
  }
`;

const CheckIcon = styled.span`
  color: var(--primary);
  font-weight: bold;
`;

const MinusIcon = styled.span`
  color: var(--text-light);
`;

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto var(--spacing-xl);
`;

const CenteredButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-xl);
`;

export default PricingPage;
